const AppFooter = () => {
  return <></>;
};

export default AppFooter;
